<template>
  <div class="track-difficulty-filter panel">
    <span class="track-difficulty-filter-title">Сложность</span>
    <label class="track-difficulty-filter-field">
      <span class="track-difficulty-filter-label">Сезон</span>
      <select v-model="localFilter.season" @change="emitFilter">
        <option v-for="season in SEASONS" :key="season" :value="season">
          {{ seasonLabel(season) }}
        </option>
      </select>
    </label>
    <label class="track-difficulty-filter-field">
      <span class="track-difficulty-filter-label">Колёса</span>
      <select v-model="localFilter.wheelSize" @change="emitFilter">
        <option
          v-for="option in WHEEL_SIZE_FILTER_OPTIONS"
          :key="option.value || 'any'"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </label>
  </div>
</template>

<script setup>
import { reactive, watch } from 'vue'
import {
  SEASONS,
  WHEEL_SIZE_FILTER_OPTIONS,
  seasonLabel,
} from '../utils/trackFormat'

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({ season: 'summer', wheelSize: '' }),
  },
})

const emit = defineEmits(['update:modelValue'])

const localFilter = reactive({
  season: props.modelValue.season,
  wheelSize: props.modelValue.wheelSize,
})

watch(
  () => props.modelValue,
  (value) => {
    localFilter.season = value.season
    localFilter.wheelSize = value.wheelSize
  },
  { deep: true }
)

function emitFilter() {
  emit('update:modelValue', {
    season: localFilter.season,
    wheelSize: localFilter.wheelSize,
  })
}
</script>

<style scoped>
.track-difficulty-filter {
  display: grid;
  gap: 0.75rem 1rem;
  align-items: end;
  margin-bottom: 1rem;
  grid-template-columns: 1fr 1fr;
}

.track-difficulty-filter-title {
  grid-column: 1 / -1;
  font-weight: 600;
  color: #0f172a;
}

.track-difficulty-filter-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}

.track-difficulty-filter-label {
  font-size: 0.875rem;
  color: #475569;
}

.track-difficulty-filter-field select {
  width: 100%;
  min-height: 2.5rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: #fff;
}

@media (min-width: 768px) {
  .track-difficulty-filter {
    grid-template-columns: auto 1fr 1fr;
  }

  .track-difficulty-filter-title {
    grid-column: auto;
    align-self: end;
    padding-bottom: 0.5rem;
  }
}
</style>
